import { React, useState, useEffect } from 'react';
import './ReportsPage.css';

export default function MonthlyBookingsPage() {
    const [loading, setLoading] = useState(false)
    const [monthlyBookings, setMonthlyBookings] = useState({ "data": [] })
    const [hasBookings, setHasBookings] = useState(false)

    async function GetThisMonthsBookings() {
        await fetch('https://mrwp.kardall.com/monthlyschoolbookings', {
                method: 'GET',
            })
            .then( r => r.json())
            .then( d => {
                setMonthlyBookings(d)
                if(d.data.length > 0) {
                    setHasBookings(true)
                }
            })
            .catch(err => console.log(err))
        setLoading(false)
        
    }

    function tConvert (time) {
        // Check correct time format and split into components
        time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      
        if (time.length > 1) { // If time format correct
          time = time.slice (1);  // Remove full string match value
          time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join (''); // return adjusted time or original string
    }

    useState(() => {
        if(!loading) {
            setLoading(true)
            GetThisMonthsBookings()
        }
    }, [monthlyBookings])

    function getFormattedDate(timestamp) {
        var date = new Date(timestamp);

        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var min = date.getMinutes();
        var sec = date.getSeconds();

        month = (month < 10 ? "0" : "") + month;
        day = (day < 10 ? "0" : "") + day;
        hour = (hour < 10 ? "0" : "") + hour;
        min = (min < 10 ? "0" : "") + min;
        sec = (sec < 10 ? "0" : "") + sec;

        const monthToWord = {
            "01": "Jan",
            "02": "Feb",
            "03": "Mar",
            "04": "Apr",
            "05": "May",
            "06": "Jun",
            "07": "Jul",
            "08": "Aug",
            "09": "Sep",
            "10": "Oct",
            "11": "Nov",
            "12": "Dec"
        }
        var str = monthToWord[month] + ", " + day

        /*alert(str);*/

        return str;
    }


    if(hasBookings) {
        return (
                <div className="admin-container">
                        <div className="column">
                            <h2>This Months Bookings</h2>
                            {monthlyBookings.data.map(
                                (booking, index) => (
                                <div key={index} className="booking-card">
                                    {console.log(booking)}
                                    <div className="RowData"><span>Date: {getFormattedDate(booking.booking_date)}</span></div>
                                    <div className="RowData"><span>Group: {booking.school_name}</span><span>Contact: {booking.booking_contact_name}</span><span>Phone: {booking.booking_contact_phone}</span><span>Alt. Phone: {booking.booking_contact2_phone}</span></div>
                                    <div className="RowData"><span>Arrival: {booking.booking_arrival}</span><span>Departure: {booking.booking_departure}</span><span>Lunch Time: {booking.booking_pizza_time}</span><span>Tube: {booking.booking_tube}</span></div>
                                    <div className="RowData"><span>Size: {booking.booking_group}</span><span>Ski: {booking.booking_ski}</span><span>Board: {booking.booking_snowboard}</span><span>Tube: {booking.booking_tube}</span></div>
                                    
                                </div>))
                            }
                        </div>
                        <div className="column pagebreak">
                            
                        </div>
                </div>
            )
    } else {
        return (
        <div className="admin-container">
                <div className="column">
                    <h2>This Months Bookings</h2>
                    <div>
                        <p>No bookings for this month</p>
                    </div>
                </div>
                <div className="column pagebreak">
                    
                </div>
        </div>
    )
    }
    
}